import { default as paymentPlanMessages } from './PaymentPlan/messages';
import { default as paymentScreenMessages } from './screens/PaymentScreen/messages';

export default {
	...paymentPlanMessages,
	...paymentScreenMessages,
};
